import {Component, ViewChild} from "@angular/core";
import {IonicPage, Keyboard, NavController, NavParams} from "ionic-angular";
import { AuthService } from "../../services/authService";
import { WelcomePage } from "../welcome/welcome";
import { Patient } from "../../models/patient.model";
import {CurrentPatientService} from "../../services/currentPatient";
import {FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";

@IonicPage({
  segment: 'insert-data',
  defaultHistory: ['welcome']
})
@Component({
  selector: "page-insert-patient-data",
  templateUrl: "insert-patient-data.html"
})
export class InsertPatientDataPage {
  patient: Patient = new Patient();
  keyboardOpen = false;

  patientForm : FormGroup;

  @ViewChild('ageInput') ageInput;

  patientValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const years = control.get('ageYears');
    const months = control.get('ageMonths');
    const height = control.get('height');
    const weight = control.get('weight');
    const totalAgeInMonths = ((+years.value) * 12) + (+months.value);

    const noValues = !years.value && !months.value && !height.value && !weight.value;
    const badAge = totalAgeInMonths > 252 ;

    return noValues || badAge? { 'noValues': noValues , 'badAge' : badAge  } : null;
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthService,
    private currentPatientService: CurrentPatientService,
    private fb: FormBuilder,
    public keyboard : Keyboard
  ) {
      this.initForm();
  }

  insertPatientData() {
    this.currentPatientService.set(this.sanitize( Object.assign({},this.patientForm.value)));
    this.navCtrl.push('OverviewResults');
  }
  
  sanitize(patient: Patient): Patient {
    patient.ageYears = patient.ageYears? +patient.ageYears : 0;
    patient.ageMonths = patient.ageMonths? +patient.ageMonths : 0;
    patient.height = patient.height? +patient.height : 0;
    patient.weight = patient.weight? +patient.weight : 0;
    return patient;
  }

  resetPatient() {
    this.currentPatientService.reset();
    this.patient = new Patient();
  }

  async logout() {
    await this.auth.logout();
    this.navCtrl.popAll();
    this.navCtrl.push(WelcomePage);
  }

  ionViewDidLoad() {
    this.keyboard.willShow.subscribe( () => {
      this.keyboardOpen = true;
    })
    this.keyboard.didHide.subscribe(() => {
      this.keyboardOpen = false;
    })
  }

  ionViewWillEnter() {
    this.resetPatient();
    this.initForm();
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.ageInput.setFocus();
    },0)
  }

  initForm() {
    this.patientForm = this.fb.group({
      height: [null, [ Validators.min(45), Validators.max(160)]],
      weight: [null, [ Validators.min(2), Validators.max(90)]],
      ageYears: [null, [ Validators.min(0), Validators.max(21)]],
      ageMonths: [null, [ Validators.min(0), Validators.max(252)]],
    }, {
      validator: this.patientValidator
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/insert-patient-data/insert-patient-data.ts